<template>
  <div class="d-flex justify-content-center align-items-center w-100">
    <div v-if="show" class="d-flex preloader-wrapper justify-content-center align-items-center h-100 w-100">
      <div class="d-flex preloader animated fadeIn"></div>
    </div>
    <slot></slot>
  </div>
</template>

<style lang="sass">
  // @import "~/../scss/style.scss"
  // @import "~bootstrap/scss/bootstrap-reboot"

  .preloader-wrapper
    position: absolute
    background: rgba(240, 240, 240, 0.7)
    transition: .400s ease-in-out
    z-index: 999
    .preloader
      color: #5d1219
      width: 40px
      height: 40px
      display: inline-block
      padding: 0px
      border-radius: 100%
      border: 2px solid
      border-top-color: rgba(93, 18, 25, 0.75)
      border-bottom-color: rgba(93, 18, 25, 0.75)
      border-left-color: rgba(93, 18, 25, 0.15)
      border-right-color: rgba(93, 18, 25, 0.15)
      -webkit-animation: preloader 0.8s linear infinite
      animation: preloader 0.8s linear infinite

  @keyframes preloader
    from
      transform: rotate(0deg)
    to
      transform: rotate(360deg)

  @-webkit-keyframes preloader
    from
      -webkit-transform: rotate(0deg)
    to
      -webkit-transform: rotate(360deg)
</style>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: true
      },

      label: {
        type: String,
        default: ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/Preloader.vue